<!-- 课程 -->
<template>
    <el-dialog v-dialogDrag :title="ruleForm.name" :visible.sync="dialogVisible" width="70%" top="200px"
        :modal-append-to-body="false">

        <!-- v-if  从新渲染 -->
        <div class="content" v-html="ruleForm.describe">

        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            dialogVisible: false,
            title: '批量竞价',
            ruleForm: {

            },
            postForm: {
                'enterprise_id': localStorage.getItem('enterprise_id'),
                'enterprise_name': '',
                biddings: []
            },
            options: JSON.parse(localStorage.getItem('entinfolist')),
            rules: {
                outline_name: [
                    { required: true, message: '请输入课程名称', trigger: 'blur' },

                ],
                enterprise_id: [
                    { required: true, message: '请选择所属企业', trigger: 'change' }
                ],
            }
        }
    },
    created() {

    },
    methods: {
        init(data) {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.hrprotocolDetail, {
                    data: {
                        "code": 'CR20250718-GZ01'
                    }
                }
                )
                .then((res) => {
                    if (res.data.code == 0) {
                        this.ruleForm = res.data.data
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {

                });
        },
        handleClose(done) {

            done();

        },
        handleOk() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.postForm.biddings.forEach(item => {
                        item.quoted_price = Number(item.quoted_price) + Number(this.ruleForm.quoted_price)
                    })



                    this.$tools
                        .asyncPost(
                            this,
                            this.$baseUrl.biddingApplicationBatchAdd, {
                            data: this.postForm
                        }).then((res) => {
                            if (res.data.code == 0) {
                                this.$message({ type: "success", message: '添加成功' });
                                this.$emit('ok')
                                this.dialogVisible = false


                            } else {
                                this.$message({ type: "error", message: res.data.msg });
                            }
                        }).catch((err) => {
                            // this.loading = false; 
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        recursion(arr) {
            let obj;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].options) {
                    obj = this.recursion(arr[i].options)
                    if (obj) {
                        return obj
                    }
                }
                if (arr[i].enterprise_id && arr[i].enterprise_id == this.postForm.enterprise_id) {
                    // obj = arr[i]

                    return arr[i];
                }
            }

        },
        handleChange(value) {
            console.log(value);
            let obj = this.recursion(this.options)

            this.ruleForm.enterprise_name = obj.enterprise_name
        },

        getOptions() {


            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingOutlineTree, {
                    data: this.postForm3
                }).then((res) => {
                    if (res.data.code == 0) {
                        res.data.data.forEach(item => {
                            item.fold = true
                        })
                        this.options = res.data.data


                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { this.loading = false; });
        },
    }
}
</script>

<style lang="less" scoped>
.content {
    height: 90vh;
    overflow-y: auto;
    text-indent: 2em;
    white-space: pre-wrap !important;
    padding: 15px;
}
</style>
